import { PropTypes } from "prop-types";
import { Link } from "gatsby";

import useResponsiveWithHydrationFix from "../../../../../../hooks/useResponsiveWithHydrationFix";

import ArrowRoundSm from "../../../../../icons/svgs/arrow-circle-sm.svg";

function SearchCard({ card }) {
  const backgroundImage = useResponsiveWithHydrationFix(
    card.image.mobileImage.file.url,
    card.image.desktopImage.file.url
  );
  const { link } = card.image;

  if (link && link?.title !== "empty") {
    return (
      <Link
        className="flex bg-no-repeat bg-cover h-[100px] desktop:h-[170px] rounded-[8px]"
        style={{
          backgroundImage: card.image ? `url(${backgroundImage})` : "none",
        }}
        to={link?.link?.link}
      >
        <p className="ml-[15px] mb-[15px] mt-auto text text--bold">{card.title}</p>
        {card.showArrow && (
          <ArrowRoundSm
            className="ml-[5px] mb-[15px] mt-auto rotate-180"
            width="21"
            stroke="#2D2927"
          />
        )}
      </Link>
    );
  }
  return (
    <div
      className="flex bg-no-repeat bg-cover h-[100px] desktop:h-[170px] rounded-[8px]"
      style={{
        backgroundImage: card.image ? `url(${backgroundImage})` : "none",
      }}
    >
      <p className="ml-[15px] mb-[15px] mt-auto text text--bold">{card.title}</p>
      {card.showArrow && (
        <ArrowRoundSm
          className="ml-[5px] mb-[15px] mt-auto rotate-180"
          width="21"
          stroke="#2D2927"
        />
      )}
    </div>
  );
}

SearchCard.propTypes = {
  card: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.shape({
      link: PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.shape({
          link: PropTypes.string,
        }),
      }),
      mobileImage: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
      desktopImage: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    showArrow: PropTypes.bool,
  }),
};
export default SearchCard;
